import { NewsCardList } from "@lists/NewsCardList";
import { SectionHeading } from "components/SectionHeading";
import { NewsListResponse } from "@interfaces/news.interface";
import {
  LagosArticles,
  LekkiArticles,
  ShortletArticles,
} from "@pages/SeoPages/Articles";

interface ExploreBlogSectionProps {
  news: NewsListResponse[];
  articleKey?: string;
  showShortletArticles?: boolean;
  heading?: {
    title: string;
    text: string;
  };
}

const renderLocationArticles = (
  articleKey?: string,
  showShortletArticles = false,
) => {
  if (articleKey === "lekki") {
    return <LekkiArticles />;
  }

  if (
    articleKey &&
    ["yaba", "surulere", "victoria+island", "victoriaisland", "lekki"].includes(
      articleKey,
    )
  ) {
    return <LagosArticles />;
  }

  if (showShortletArticles || !articleKey) {
    return <ShortletArticles />;
  }

  return null;
};

export const ExploreBlogSection = ({
  news,
  articleKey,
  showShortletArticles = false,
  heading = {
    title: "Blog Posts",
    text: "Latest insights and guides",
  },
}: ExploreBlogSectionProps) => {
  const shouldShowArticles = Boolean(articleKey || showShortletArticles);

  return (
    <>
      {shouldShowArticles && (
        <section className="py-5">
          <div className="container">
            {renderLocationArticles(articleKey, showShortletArticles)}
          </div>
        </section>
      )}

      <section className="py-5">
        <div className="container">
          <SectionHeading title={heading.title} text={heading.text} />

          <NewsCardList lg={3} news={news.slice(0, 3)} />
        </div>
      </section>
    </>
  );
};
